import * as employeeTypes from '../actionTypes/employeeTypes';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import {
    failToast,
    infoToast,
    succToast,
    serverNotRespond,
} from "../../helper/ApiToast";
import {
    addTeamMember,
    deleteMemberList,
    updateUserDetail,
    getMemberListData,
    getSingleUserDetails,
    getRoleAccessData,
    getSaveorEditData,
    getMemberRecentChatData,
    getMemberChatHistory,
    chatMediaDownloadService,
} from '../../services/employeeService';
import { getCalluseageDetailsApiCall } from '../../components/MainContent/Dashboard/DashBoardAnalyticsOverview/AnalyticsCommon';
import store from '..';
import { chatMediaDownloadMethod } from '../../components/MainContent/ManageEmployee/ChatHistory/helpers';

function* addMemberSaga(obj = {}) {
    try {
        const response = yield call(addTeamMember, obj);
        const { data: { status = 0, message = "" } = {} } = response || {};
        if (status === 200) {
            succToast(message);
            yield all([
                put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }), //load teams page on success of api call
                put({ type: "MEMBER_POPUP_OPEN", memberPopupOpen: false })//poPop  close afetr success
            ]);
        } else {
            failToast(message);
            yield put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }); //load teams page on success of api call
        }
    }
    catch (error) {
        serverNotRespond();
        yield put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }); //load teams page on success of api call

    }
}

/**
 * @param  {object} obj
 * update
 */
function* updateUserDetails(obj = {}) { //Edit or Update Call
    try {
        const updateCusData = yield call(updateUserDetail, obj);
        const { data: { status = 0, message = "" } = {} } = updateCusData || {};
        if (status === 200) {
            succToast(message);
            yield all([
                put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false, isFromUpdate: obj?.data?.isFromUpdate }), //load teams page on success of api call
                put({ type: "MEMBER_POPUP_OPEN", memberPopupOpen: false })
            ]);
        } else {
            failToast(message);
            yield put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }); //load teams page on success of api call
        }
    }
    catch (error) {
        serverNotRespond();
        yield put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }); //load teams page on success of api call
    }
}

/**
 * @param  {object} obj={}
 * getMemberList
 */
function* getMemberList(obj = {}) { //GetMember Data
    try {
        const getMemberData = yield call(getMemberListData, obj);
        const { data = {} } = getMemberData || {};
        const { status = 0 } = data || {};
        if (status >= 200 && status <= 300) {
            yield all([
                put({ type: "GET_EMPLOYEE_LIST_DATA", MemberData: data }),//GetMember List and store
                put({ type: "GET_EMPLOYEE_LIST_DATA_LOAD", memberListLoad: false }),
            ]);
        } else {
            serverNotRespond(); //serverIs Not Respont Call this Toast
            yield all([
                put({ type: "GET_EMPLOYEE_LIST_DATA_LOAD", memberListLoad: false }),
            ]);
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "GET_EMPLOYEE_LIST_DATA_LOAD", memberListLoad: false }),
        ]);
    }
}

/**
 * @param  {object} obj;
 * inside object have array is contain
 * have user deleted id
 */
function* deleteMember(obj = {}) {
    try {
        const delCusData = yield call(deleteMemberList, obj);
        const { data: { status = 0, message = "" } = {} } = delCusData || {};
        if (status === 200) {
            succToast(message);//
            yield all([
                put({ type: "MEMBER_POPUP_OPEN", memberPopupOpen: false }),//close side menu popUp
                put({ type: "EMPLOYEE_RELOAD_LOADER", loading: false }),//deleted seccuessfull list reRender
            ]);
        } else {
            infoToast(message); //200 status missing
            yield all([
                put({ type: "EMPLOYEE_RELOAD_LOADER", memberListLoad: false }),//deleted seccuessfull list reRender
            ]);
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "EMPLOYEE_RELOAD_LOADER", memberListLoad: false }),//deleted seccuessfull list reRender
        ]);
    }
}

function* getUserDetails(obj = {}) {
    try {
        const delCusData = yield call(getSingleUserDetails, obj);
        const { data: { status = 0, message = "", data = {} } = {} } = delCusData || {};
        if (status === 200) {
            yield all([
                put({ type: "MEMBER_CUSTOMER_DETAILS", userDtls: data }),//Result Store
                put({ type: "EDIT_MEMBER_LOADER", editLoader: false }),//Loader open/close
            ]);
        } else {
            failToast(message);
            yield all([
                put({ type: "MEMBER_CUSTOMER_DETAILS", userDtls: {} }),//Result Store
                put({ type: "EDIT_MEMBER_LOADER", editLoader: false }),//Loader open/close
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "EDIT_MEMBER_LOADER", editLoader: false }),// Loader open/close
        ]);
        serverNotRespond(); //serverIs Not Respont Call this Toast
    }
}

/**
 * @param  {object} obj={}
 * getMemberList
 */
function* getCallUasgeListSaga(obj = {}) { //GetMember Data
    yield put({ type: "GET_EMPLOYEE_LIST_DATA_LOAD", memberListLoad: true });
    try {
        const response = yield call(getCalluseageDetailsApiCall, obj.data);
        const { data: { status = 0 } } = response || {};
        if (status === 200) {
            yield put({ type: "GET_CALL_USAGE_LIST_DATA", callUsageData: response.data || {} });
        } else {
            serverNotRespond(); //serverIs Not Respont Call this Toast
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
    }
    yield put({ type: "GET_EMPLOYEE_LIST_DATA_LOAD", memberListLoad: false });
}
function* getRoleAccessList(obj = {}) { //GetMember Data
    try {
        const getRoleAccess = yield call(getRoleAccessData, obj);
        const { data = {} } = getRoleAccess || {};
        const { status = 0, message = "" } = data;
        if (status >= 200 && status <= 300) {
            yield all([
                put({ type: "GET_ROLE_ACCESS_DATA", roleAccessList: data }),
                put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }),
            ]);
        } else {
            serverNotRespond(message); //serverIs Not Respont Call this Toast
            yield all([
                put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }),
            ]);
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }),
        ]);
    }
}
function* saveAndEditSaga(obj = {}) {
    try {
        const response = yield call(getSaveorEditData, obj);
        const { data: { status = 0, message = "" } = {} } = response || {};
        if (status === 200) {
            succToast(message);
            yield all([
                put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }),
                put({ type: "SAVE_AND_EDIT_DATA", saveAndEditData: data })//poPop  close afetr success
            ]);
        } else {
            failToast(message);
            yield put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }) ;//load teams page on success of api call
        }
    }
    catch (error) {
        serverNotRespond();
        yield put({ type: "GET_ROLE_ACCESS_DATA_LOAD", roleAccessLoader: false }) ;//load teams page on success of api call

    }
}
function* getSideMenuDetailsSaga(obj) { //Singele Profile view
    try {
        const getRoleAccess = yield call(getRoleAccessData, obj);
        const { data = {} } = getRoleAccess || {};
        const { status = 0} = data;
        if (status === 200) {
            yield all([
                put({ type: "SIDEMENU_DETAILS", sideMenuDtls: data }),//Result Store
            ]);
        } else {
            yield all([
                put({ type: "SIDEMENU_DETAILS", sideMenuDtls: {} }),//Result Store
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "SIDEMENU_DETAILS", sideMenuDtls: {} }),//Result Store
        ]);
    }
}

function* getMemberRecentChat(obj = {}) { //GetMember Recent chat data
    try {
        if(!obj?.data?.username) return;
        if(obj.allowLoad){
            store.dispatch({ type : 'GET_MEMBER_RECENT_CHAT_DATA_LOAD', memberRecentChatLoading: true });
        }
        const append = !obj.allowLoad;
        delete obj.allowLoad;
        const getMemberRecentChatList = yield call(getMemberRecentChatData, obj);
        const { data = {} } = getMemberRecentChatList || {};
        const { status = 0 } = data || {};
        if (status === 200) {
            yield all([
                put({ type: "GET_MEMBER_RECENT_CHAT", memberRecentChatData: data, reset: !append }),
                put({ type: "GET_MEMBER_RECENT_CHAT_DATA_LOAD", memberRecentChatLoading: false }),
                put({ type: "SELECTED_MEMBER_USER_ID", selectedUserId: obj.data.username }),
            ]);
        } else {
            serverNotRespond();
            yield all([
                put({ type: "RESET_MEMBER_RECENT_CHAT"}),
                put({ type: "GET_MEMBER_RECENT_CHAT_DATA_LOAD", memberRecentChatLoading: false }),
                put({ type: "SELECTED_MEMBER_USER_ID", selectedUserId: obj.data.username }),
            ]);
        }
    }
    catch (error) {
        serverNotRespond();
        yield all([
                put({ type: "RESET_MEMBER_RECENT_CHAT"}),
                put({ type: "GET_MEMBER_RECENT_CHAT_DATA_LOAD", memberRecentChatLoading: false }),
                put({ type: "SELECTED_MEMBER_USER_ID", selectedUserId: obj.data.username }),

       ]);
    }
}

function* getMemberChatHistoryData(obj = {}) { //GetMember Chat History data
    try {
        if(!(obj?.data?.fromUser || obj?.data?.toUser)) return;
        if(obj.allowLoad){
            store.dispatch({ type : 'GET_MEMBER_CHAT_HISTORY_DATA_LOAD', memberChatHistoryLoading: true });
        }
        const append = !obj.allowLoad;
        delete obj.allowLoad;
        const getMemberChatHistoryList = yield call(getMemberChatHistory, obj);
        const { data = {} } = getMemberChatHistoryList || {};
        const { status = 0 } = data || {};
        if (status === 200) {
            yield all([
                put({ type: "GET_MEMBER_CHAT_HISTORY", memberChatHistory: data, reset: !append }),
                put({ type: "GET_MEMBER_CHAT_HISTORY_DATA_LOAD", memberChatHistoryLoading: false }),
            ]);
        } else {
            serverNotRespond();
            yield all([
                put({ type: "RESET_MEMBER_CHAT_HISTORY"}),
                put({ type: "GET_MEMBER_CHAT_HISTORY_DATA_LOAD", memberChatHistoryLoading: false }),
            ]);
        }
    }
    catch (error) {
        serverNotRespond();
        yield all([
                put({ type: "RESET_MEMBER_CHAT_HISTORY"}),
                put({ type: "GET_MEMBER_CHAT_HISTORY_DATA_LOAD", memberChatHistoryLoading: false }),
       ]);
    }
};
function* chatMediaDownloadSaga(obj) {
    try {
        const decryptDataNeeded ={
            fileKey: obj?.data?.fileKey,
            fileName: obj?.data?.fileName,
            fileToken: obj?.data?.fileToken,
        }
        delete obj.data.fileKey;
        delete obj.data.fileName;
        const response = yield call(chatMediaDownloadService, obj);
        const { data = {} } = response || {};
        if (data) {
            if (!obj?.isProfileImage && !obj?.isChatPartnerImage) {
                store.dispatch({ type: 'ADD_DOWNLOADING_MESSAGE', msgId: obj?.data?.fileToken });
                yield all([
                    put({ type: "CHAT_MEDIA_DOWNLOAD_DATA", chatMediaDownloadData: data }),
                    chatMediaDownloadMethod(data?.mediaUrl,decryptDataNeeded)
                ]);
            }
            else if (obj?.isChatPartnerImage) {
                yield all([
                    put({ type: "CHAT_PARTNER_MEDIA_DOWNLOAD_DATA", chatPartnerMediaDownloadData: data }),
                ]);
            }
            else {
                yield all([
                    put({ type: "PROFILE_MEDIA_DOWNLOAD_DATA", profileMediaDownloadData: data }),
                ]);
            }
        } else {
            if (!obj?.isProfileImage) {
                store.dispatch({ type: 'REMOVE_DOWNLOADING_MESSAGE', msgId: decryptDataNeeded.fileToken });
                yield all([
                    put({ type: "CHAT_MEDIA_DOWNLOAD_DATA", chatMediaDownloadData: {} }),
                ]);
            }
            else if (obj?.isChatPartnerImage) {
                yield all([
                    put({ type: "CHAT_PARTNER_MEDIA_DOWNLOAD_DATA", chatPartnerMediaDownloadData: {} }),
                ]);
            }
            else {
                yield all([
                    put({ type: "PROFILE_MEDIA_DOWNLOAD_DATA", profileMediaDownloadData: {} }),
                ]);
            }
        }
    }
    catch (error) {
        if (!obj?.isProfileImage) {
            store.dispatch({ type: 'REMOVE_DOWNLOADING_MESSAGE', msgId: obj?.data?.fileToken });
            yield all([
                put({ type: "CHAT_MEDIA_DOWNLOAD_DATA", chatMediaDownloadData: {} }),
            ]);
        }
        else if (obj?.isChatPartnerImage) {
            yield all([
                put({ type: "CHAT_PARTNER_MEDIA_DOWNLOAD_DATA", chatPartnerMediaDownloadData: {} }),
            ]);
        }
        else {
            yield all([
                put({ type: "PROFILE_MEDIA_DOWNLOAD_DATA", profileMediaDownloadData: {} }),
            ]);
        }
    }
}

export default function* employeeSaga() {
    yield takeLatest(employeeTypes.EMPLOYEE_DELETE, deleteMember);
    yield takeLatest(employeeTypes.TYPE_ADD_EMPLOYEE, addMemberSaga);
    yield takeLatest(employeeTypes.GET_EMPLOYEE_LIST, getMemberList);
    yield takeLatest(employeeTypes.GET_EMPLOYEE_DETAILS, getUserDetails);
    yield takeLatest(employeeTypes.UPDATE_EMPLOYEE_DETAILS, updateUserDetails);
    yield takeLatest(employeeTypes.GET_CALL_UASGE_LIST, getCallUasgeListSaga);
    yield takeLatest(employeeTypes.GET_ROLE_ACCESS_LIST, getRoleAccessList);
    yield takeLatest(employeeTypes.GET_SIDEMENU_DETAILS, getSideMenuDetailsSaga);
    yield takeLatest(employeeTypes.GET_SAVE_AND_EDIT_DATA, saveAndEditSaga);
    yield takeLatest(employeeTypes.GET_MEMBER_RECENT_CHAT, getMemberRecentChat);
    yield takeLatest(employeeTypes.GET_MEMBER_CHAT_HISTORY, getMemberChatHistoryData);
    yield takeLatest(employeeTypes.CHAT_MEDIA_DOWNLOAD, chatMediaDownloadSaga);
}
